<div class="design-search-container">
  <div class="search-input-wrapper">
    <input 
      type="text" 
      class="form-control search-input"
      [placeholder]="placeholder"
      [(ngModel)]="searchKeyword"
      (input)="onSearchInput($event)"
      autocomplete="off"
    />
    <div class="search-icon">
      <i class="fas fa-search"></i>
    </div>
  </div>

  <!-- Loading indicator -->
  <div *ngIf="isLoading" class="loading-indicator">
    <i class="fas fa-spinner fa-spin"></i> Đang tìm kiếm...
  </div>

  <!-- Search results dropdown -->
  <div *ngIf="showResults && !isLoading" class="search-results">
    <div *ngIf="searchResults.length === 0" class="no-results">
      Không tìm thấy thiết kế nào
    </div>
    
    <div *ngFor="let design of searchResults" 
         class="design-result-item"
         (click)="selectDesign(design)">
      
             <div class="design-preview">
         <img *ngFor="let thumbnail of design.destinationProductThumbnail?.split('\n') || []; let i = index" 
              [src]="thumbnail" 
              [alt]="design.productName + ' - Image ' + (i + 1)"
              class="preview-image"
              (error)="$event.target.style.display='none'"
         />
       </div>
    </div>
  </div>
</div>
